import { NodeType, Node } from '@tiptap/pm/model'
import { Command } from '@tiptap/pm/state'
import {
  selectedRect,
  TableRect,
  isInTable,
  tableNodeTypes,
  ToggleHeaderType,
} from '@tiptap/pm/tables'

function isHeaderEnabledByType(
  type: 'row' | 'column',
  rect: TableRect,
  types: Record<string, NodeType>,
): boolean {
  // Get cell positions for first row or first column
  const cellPositions = rect.map.cellsInRect({
    left: 0,
    top: 0,
    right: type === 'row' ? rect.map.width : 1,
    bottom: type === 'column' ? rect.map.height : 1,
  })

  for (let i = 0; i < cellPositions.length; i++) {
    const cell = rect.table.nodeAt(cellPositions[i])
    if (cell && cell.type !== types.header_cell) {
      return false
    }
  }

  return true
}

export function toggleHeader(type: ToggleHeaderType): Command {
  return (state, dispatch) => {
    if (!isInTable(state)) {
      return false
    }
    if (dispatch) {
      const types = tableNodeTypes(state.schema)
      const rect = selectedRect(state)
      const { tr } = state

      const isHeaderRowEnabled = isHeaderEnabledByType('row', rect, types)
      const isHeaderColumnEnabled = isHeaderEnabledByType('column', rect, types)
      let isHeaderEnabled = false

      if (type === 'column') {
        isHeaderEnabled = isHeaderRowEnabled
      } else if (type === 'row') {
        isHeaderEnabled = isHeaderColumnEnabled
      }

      const selectionStartsAt = isHeaderEnabled ? 1 : 0

      let cellsRect = rect
      if (type === 'column') {
        cellsRect = {
          ...rect,
          left: 0,
          top: selectionStartsAt,
          right: 1,
          bottom: rect.map.height,
        }
      } else if (type === 'row') {
        cellsRect = {
          ...rect,
          left: selectionStartsAt,
          top: 0,
          right: rect.map.width,
          bottom: 1,
        }
      }

      let newType = types.cell
      if (type === 'column') {
        newType = isHeaderColumnEnabled ? types.cell : types.header_cell
      } else if (type === 'row') {
        newType = isHeaderRowEnabled ? types.cell : types.header_cell
      }

      rect.map.cellsInRect(cellsRect).forEach(relativeCellPos => {
        const cellPos = relativeCellPos + rect.tableStart
        const cell = tr.doc.nodeAt(cellPos)

        if (cell) {
          tr.setNodeMarkup(cellPos, newType, {
            ...cell.attrs,
            class: (newType as unknown as Node).attrs?.class?.default,
          })
        }
      })

      dispatch(tr)
    }
    return true
  }
}
